export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-700 via-teal-600 to-teal-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold mb-6">株式会社南場組</h3>
            <p className="text-teal-50 leading-relaxed mb-4">
              新潟市江南区早通で創業70年以上。土木工事、舗装工事、下水道工事、用水路工事を手掛ける総合建設業として、地域のインフラを支え続けています。
            </p>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-6">事業内容</h4>
            <ul className="space-y-3 text-teal-50">
              <li className="flex items-start">
                <i className="ri-check-line text-teal-200 mr-2 mt-1"></i>
                <span>土木工事</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-teal-200 mr-2 mt-1"></i>
                <span>舗装工事</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-teal-200 mr-2 mt-1"></i>
                <span>下水道工事</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-teal-200 mr-2 mt-1"></i>
                <span>用水路・排水路工事</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-6">お問い合わせ</h4>
            <div className="space-y-4 text-teal-50">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-teal-200 mr-3 mt-1 text-xl"></i>
                <div>
                  <p className="font-semibold mb-1">所在地</p>
                  <p>〒950-0168<br />新潟市江南区早通4丁目1番21号</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-phone-line text-teal-200 mr-3 mt-1 text-xl"></i>
                <div>
                  <p className="font-semibold mb-1">電話</p>
                  <p>025-381-2476</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-teal-500/30 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-teal-100 text-sm">
              &copy; {new Date().getFullYear()} 株式会社南場組. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}